<ion-header>
  <ion-toolbar>
    <ion-title>Bind device</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form (ngSubmit)="save()">
    <ion-list>
      <ion-item>
        <ion-label>
          <p>Zone</p>
          <h3>{{ zone?.name }}</h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <p>Level</p>
          <h3>{{ level?.name || 'No level' }}</h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <p>Group</p>
          <h3>{{ group?.name }}</h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <app-device-input
          [error]="error"
          (newDevice)="newDevice($event)"
          (calibrationStatus)="calibrationStatus($event)"
        ></app-device-input>
      </ion-item>
      <ion-item>
        <ion-input
          type="text"
          autocomplete="off"
          [(ngModel)]="customId"
          [ngModelOptions]="{standalone: true}"
          (click)="blurInput()"
          label="Custom ID"
          labelPlacement="floating"
          placeholder=""
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          type="text"
          autocomplete="off"
          [value]="networkId"
          [ngModelOptions]="{standalone: true}"
          disabled
          label="Network ID"
          labelPlacement="floating"
          placeholder=""
        ></ion-input>
      </ion-item>
    </ion-list>
    <button type="submit" style="display:none">hidden submit hack</button>
  </form>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-button expand="full" (click)="save()" [disabled]="customId === position?.custom_id && !deviceForBind">save and bind</ion-button>
  </ion-toolbar>
</ion-footer>
  